import axiosInstance from "utils/axios-request";
import {gatewayUrl} from "config";

export const initiateOkyc = async (): Promise<{session_id: string, captcha: string}> => {
  const res = await axiosInstance.request({
    baseURL: gatewayUrl,
    url: `/kyc/initiate-okyc`,
    method: "get",
  });
  return res.data;
};

export const generateCaptcha = async (params: {session_id: string}): Promise<{captcha: string}> => {
  const res = await axiosInstance.request({
    baseURL: gatewayUrl,
    url: `/kyc/captcha`,
    method: "get",
    params,
  });
  return res.data;
};

export const generateOtp = async (data: {session_id: string, captcha: string, aadhaar_no: number}): Promise<string> => {
  const res = await axiosInstance.request({
    baseURL: gatewayUrl,
    url: `/kyc/generate-otp`,
    method: "post",
    data,
  });
  return res.data;
};

export const validateOtp = async (data: {session_id: string, otp: number, userId: number}):
Promise<{isSuccess: boolean, message: string}> => {
  const res = await axiosInstance.request({
    baseURL: gatewayUrl,
    url: `/kyc/validate-otp`,
    method: "post",
    data,
  });
  return res.data;
};
